import { lazy } from 'react';
import { IA_KEY } from 'helpers/ia-logic';
import { NAV_KEY } from 'constants/venue-experience';
import { PAGE_LAYOUT_VARIANT } from 'features/App';
import { handleDynamicPricingRouteEnter, watchDynamicPricingPage } from 'features/DynamicPricing/DynamicPricing.saga';
import {
  handleClassesRouteEnter,
  watchSchedulesClassesActions,
} from 'features/ClassDetail/ClassDetailTable/ClassDetailTable.saga';
import { handleClassRouteEnter, watchClassDetailPage } from 'features/ClassDetail/ClassDetail.saga';
import {
  handleRouteEnter as handlePremiumCapsRouteEnter,
  watchActions as watchPremiumCapsActions,
} from 'features/PremiumCaps/PremiumCaps.saga';
import { handleVenueRouteEnter, watchVenuePage } from 'features/VenuePage/VenuePage.saga';
import {
  watchMsiChangelogActions,
  handleInitializeMsiChangelog,
} from 'features/VenuePage/MsiChangelog/MsiChangelog.saga';

const DynamicPricing = lazy(() =>
  import(/* webpackChunkName: "venue-pricing" */ 'features/DynamicPricing/DynamicPricingContainer')
);
const ClassDetailTable = lazy(() =>
  import(/* webpackChunkName: "venue-class-detail-table" */ 'features/ClassDetail/ClassDetailTable').then(m => ({
    default: m.ClassDetailTable,
  }))
);
const ClassDetail = lazy(() =>
  import(/* webpackChunkName: "venue-class-detail" */ 'features/ClassDetail').then(m => ({ default: m.ClassDetail }))
);
const PremiumCaps = lazy(() =>
  import(/* webpackChunkName: "venue-premium-caps" */ 'features/PremiumCaps').then(m => ({ default: m.PremiumCaps }))
);
const VenuePage = lazy(() =>
  import(/* webpackChunkName: "venue-page" */ 'features/VenuePage').then(m => ({ default: m.VenuePage }))
);

export default [
  {
    path: '/venues/:venueId/edit/:tab?',
    component: VenuePage,
    pathSagas: [watchMsiChangelogActions, handleInitializeMsiChangelog],
    locationSagas: [handleVenueRouteEnter, watchVenuePage],
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
  },
  {
    path: '/venues/:venueId/classes/:classId',
    component: ClassDetail,
    iaKey: IA_KEY.MANAGE_CLASS_PAGES,
    navKey: NAV_KEY.EDIT_CLASS_PAGE,
    pathSagas: [watchClassDetailPage],
    locationSagas: [handleClassRouteEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.NARROW,
  },
  {
    path: '/venues/:venueId/classes',
    component: ClassDetailTable,
    navKey: NAV_KEY.EDIT_CLASS_PAGE,
    pathSagas: [watchSchedulesClassesActions],
    locationSagas: [handleClassesRouteEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
  },
  {
    path: '/venues/:venueId/dynamic-pricing',
    component: DynamicPricing,
    iaKey: IA_KEY.MANAGE_DYNAMIC_PRICING,
    navKey: NAV_KEY.DYNAMIC_PRICING,
    pathSagas: [watchDynamicPricingPage],
    locationSagas: [handleDynamicPricingRouteEnter],
  },
  {
    path: '/venues/:venueId/premium-caps',
    component: PremiumCaps,
    iaKey: IA_KEY.MANAGE_PREMIUM_CAPS,
    navKey: NAV_KEY.PREMIUM_CAPS,
    pathSagas: [watchPremiumCapsActions],
    locationSagas: [handlePremiumCapsRouteEnter],
  },
];
